<template>
  <el-select
    v-model="value"
    :placeholder="placeholder"
    @visible-change="visibleChange"
    @change="onClickSelect"
  >
    <el-option v-show="type !== 'sort'" label="全部" value="clear" />
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import { getStyleFilter } from '~/api/community.api'
export default {
  props: {
    type: {
      default: 'style',
      type: String
    }
  },
  data() {
    return {
      placeholder: '',
      options: [],
      value: ''
    }
  },

  async created() {
    await this.init()
  },
  methods: {
    initStyle,
    init,
    initRoom,
    initSort,
    onClickSelect,
    visibleChange
  }
}
function visibleChange(value) {
  this.$emit('visibleChange', value)
}
function init() {
  if (this.type === 'style') {
    this.placeholder = '风格'
    this.initStyle()
  }
  if (this.type === 'room') {
    this.placeholder = '户型'
    this.initRoom()
  }
  if (this.type === 'sort') {
    this.placeholder = '排序'
    this.initSort()
  }
}

function onClickSelect() {
  this.$nextTick(() => {
    if (this.value === 'clear') {
      this.value = null
    }
    this.$emit('change-list', this.type, this.value)
  })
}
async function initStyle() {
  const res = await getStyleFilter({ companyId: this.$route.params.companyId })
  this.options = res.map((item) => {
    return {
      value: item.id,
      label: item.name
    }
  })
}

function initRoom() {
  this.options = [
    { value: 1, label: '一居室' },
    { value: 2, label: '两居室' },
    { value: 3, label: '三居室' },
    { value: 4, label: '四居室' },
    { value: 5, label: '五居室' },
    { value: 0, label: '五居室以上' }
  ]
}
function initSort() {
  this.value = 1
  this.options = [
    { value: 1, label: '智能排序' },
    { value: 3, label: '人气最高' }
  ]
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 940px) {
  .el-select-dropdown {
    margin-top: 2px !important;
    right: 0 !important;
    left: 0 !important;
    .popper__arrow {
      display: none !important;
    }
  }
}
</style>
